import { render, staticRenderFns } from "./PageEditorPageForm.vue?vue&type=template&id=0fb2a9a6&scoped=true"
import script from "./PageEditorPageForm.vue?vue&type=script&lang=js"
export * from "./PageEditorPageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2a9a6",
  null
  
)

export default component.exports